import { Chip, Tooltip } from '@mui/material';
import { t } from 'i18next';
import { Operator } from '../enum/Operator';

type Props = {
  operator: Operator;
  onClick?: (operator: Operator) => void;
};

export const OperatorChip = ({ operator, onClick }: Props) => {
  const toggledOperator = operator === Operator.AND ? Operator.OR : Operator.AND;

  const Component = <Chip component="button" label={t(operator)} onClick={onClick ? () => onClick(toggledOperator) : undefined} />;
  if (onClick) {
    return <Tooltip title={t('toggleOperator', { operator: t(toggledOperator) })}>{Component}</Tooltip>;
  }
  return Component;
};
